import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import callApi from '../../../utils/callApi';
import { useCheckoutState } from '../../../utils/checkoutState';
import redirect from '../../../utils/redirect';
import { pushErrorTrackingEventFromErrorObject } from '../../../utils/tracking';
import { wait } from '../../../utils/wait';
import LoadingIndicator from '../../atoms/LoadingIndicator';
import { showDefaultError } from '../../molecules/Notifications';
import { PaymentConfirmationPollingResponse } from '../../organisms/PaymentConfirmationPending';
import './style.scss';

const AdyenMbwayPayment = () => {
  const { checkoutState } = useCheckoutState();
  const phoneNumber = checkoutState.customer?.data.phone?.plainText;

  useEffect(() => {
    (async () => {
      const mbwayTimeout = 60000;
      let shouldPoll = true;
      let hasTimedOut = false;
      setTimeout(() => (hasTimedOut = true), mbwayTimeout);
      while (shouldPoll) {
        try {
          const paymentConfirmationPollingResponse = await callApi<PaymentConfirmationPollingResponse>({
            endpoint: '/state/order/confirmation/status',
            allowedStatusCodes: [424]
          });

          if (paymentConfirmationPollingResponse.status === 'success') {
            redirect(paymentConfirmationPollingResponse.redirect!);
            shouldPoll = false;
          } else if (paymentConfirmationPollingResponse.status === 'failed') {
            const url = new URL(window.location.href);
            url.searchParams.delete('waitForPaymentConfirmation');
            redirect({ method: 'GET', url: url.toString() });
            shouldPoll = false;
          } else if (hasTimedOut) {
            shouldPoll = false;
          }
        } catch (e) {
          console.error(e);
          showDefaultError();
          pushErrorTrackingEventFromErrorObject(e, 'adyen_mbway');
        }
        await wait(1000);
      }
    })();
  }, []);

  return (
    <div className=" mbway__container">
      <span className="mbway__title">
        <FormattedMessage id="payment.paymentMethod.options.mbway" />
      </span>
      <span className="mbway__message">
        <FormattedMessage
          id="payment.paymentMethod.mbwayModal.authorizationPending"
          values={{ b: chunks => <b className="mbway--black">{chunks}</b> }}
        />
      </span>
      {phoneNumber && <span className="mbway__phone-number">{phoneNumber}</span>}
      <LoadingIndicator contentClassName="mbway__loading" />
      <span className="mbway__notification-not-received">
        <FormattedMessage id="payment.paymentMethod.mbwayModal.notificationNotReceived" />
      </span>
      <span className="mbway__advice">
        <FormattedMessage id="payment.paymentMethod.mbwayModal.advice" />
      </span>
    </div>
  );
};

export default AdyenMbwayPayment;
